import { SALE_FILTER_TYPE_MAP } from '../../../constants/globalTypes'

export const GA_CLICK_ACTION = {
  CATEGORY_SELECT: 'CATEGORY_SELECT',
  CHART_SORT: 'CHART_SORT'
}

const GA_KEY = {
  CATEGORY_SELECT: 'CATEGORY_SELECT',
  CHART_SORT_AMOUNT: 'CHART_SORT_AMOUNT',
  CHART_SORT_COUNT: 'CHART_SORT_COUNT'
}

const GA_KEY_MAP = {
  [GA_KEY.CATEGORY_SELECT]: 'sale_dropdownmenu',
  [GA_KEY.CHART_SORT_AMOUNT]: 'sale_orderamt',
  [GA_KEY.CHART_SORT_COUNT]: 'sale_ordercnt'
}

export const getI13nModel = (action = {}, customizeI13nModel = {}) => {
  const { type, payload } = action
  let key
  switch (type) {
    case GA_CLICK_ACTION.CHART_SORT: {
      const map = {
        [SALE_FILTER_TYPE_MAP.AMOUNT.type]: GA_KEY.CHART_SORT_AMOUNT,
        [SALE_FILTER_TYPE_MAP.COUNT.type]: GA_KEY.CHART_SORT_COUNT
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.CATEGORY_SELECT:
      key = GA_KEY[type]
      break
    default:
      break
  }
  const i13nModel = {
    label: GA_KEY_MAP[key],
    ...customizeI13nModel
  }
  return i13nModel
}
